/**
 * Curated country list for sign-up. Markets we serve heavily are at the top.
 * Format: [name, ISO-2, dial code]. Dial code includes the leading "+".
 *
 * Replace with full Intl.DisplayNames + libphonenumber-js when the colleague
 * wires this up properly.
 */
export const PRIORITY_COUNTRIES = [
  ['Lebanon',                'LB', '+961'],
  ['United Arab Emirates',   'AE', '+971'],
  ['United Kingdom',         'GB', '+44'],
  ['Saudi Arabia',           'SA', '+966'],
  ['Qatar',                  'QA', '+974'],
  ['Kuwait',                 'KW', '+965'],
  ['Jordan',                 'JO', '+962'],
  ['Egypt',                  'EG', '+20'],
]

export const REST_OF_WORLD = [
  ['Albania',                 'AL', '+355'],
  ['Algeria',                 'DZ', '+213'],
  ['Argentina',               'AR', '+54'],
  ['Armenia',                 'AM', '+374'],
  ['Australia',               'AU', '+61'],
  ['Austria',                 'AT', '+43'],
  ['Bahrain',                 'BH', '+973'],
  ['Bangladesh',              'BD', '+880'],
  ['Belgium',                 'BE', '+32'],
  ['Brazil',                  'BR', '+55'],
  ['Bulgaria',                'BG', '+359'],
  ['Canada',                  'CA', '+1'],
  ['Chile',                   'CL', '+56'],
  ['China',                   'CN', '+86'],
  ['Colombia',                'CO', '+57'],
  ['Croatia',                 'HR', '+385'],
  ['Cyprus',                  'CY', '+357'],
  ['Czechia',                 'CZ', '+420'],
  ['Denmark',                 'DK', '+45'],
  ['Estonia',                 'EE', '+372'],
  ['Finland',                 'FI', '+358'],
  ['France',                  'FR', '+33'],
  ['Georgia',                 'GE', '+995'],
  ['Germany',                 'DE', '+49'],
  ['Ghana',                   'GH', '+233'],
  ['Greece',                  'GR', '+30'],
  ['Hong Kong',               'HK', '+852'],
  ['Hungary',                 'HU', '+36'],
  ['Iceland',                 'IS', '+354'],
  ['India',                   'IN', '+91'],
  ['Indonesia',               'ID', '+62'],
  ['Iraq',                    'IQ', '+964'],
  ['Ireland',                 'IE', '+353'],
  ['Israel',                  'IL', '+972'],
  ['Italy',                   'IT', '+39'],
  ['Japan',                   'JP', '+81'],
  ['Kazakhstan',              'KZ', '+7'],
  ['Kenya',                   'KE', '+254'],
  ['Latvia',                  'LV', '+371'],
  ['Libya',                   'LY', '+218'],
  ['Lithuania',               'LT', '+370'],
  ['Luxembourg',              'LU', '+352'],
  ['Malaysia',                'MY', '+60'],
  ['Malta',                   'MT', '+356'],
  ['Mexico',                  'MX', '+52'],
  ['Morocco',                 'MA', '+212'],
  ['Netherlands',             'NL', '+31'],
  ['New Zealand',             'NZ', '+64'],
  ['Nigeria',                 'NG', '+234'],
  ['Norway',                  'NO', '+47'],
  ['Oman',                    'OM', '+968'],
  ['Pakistan',                'PK', '+92'],
  ['Palestine',               'PS', '+970'],
  ['Peru',                    'PE', '+51'],
  ['Philippines',             'PH', '+63'],
  ['Poland',                  'PL', '+48'],
  ['Portugal',                'PT', '+351'],
  ['Romania',                 'RO', '+40'],
  ['Russia',                  'RU', '+7'],
  ['Senegal',                 'SN', '+221'],
  ['Serbia',                  'RS', '+381'],
  ['Singapore',               'SG', '+65'],
  ['Slovakia',                'SK', '+421'],
  ['Slovenia',                'SI', '+386'],
  ['South Africa',            'ZA', '+27'],
  ['South Korea',             'KR', '+82'],
  ['Spain',                   'ES', '+34'],
  ['Sri Lanka',               'LK', '+94'],
  ['Sweden',                  'SE', '+46'],
  ['Switzerland',             'CH', '+41'],
  ['Syria',                   'SY', '+963'],
  ['Taiwan',                  'TW', '+886'],
  ['Tanzania',                'TZ', '+255'],
  ['Thailand',                'TH', '+66'],
  ['Tunisia',                 'TN', '+216'],
  ['Turkey',                  'TR', '+90'],
  ['Ukraine',                 'UA', '+380'],
  ['United States',           'US', '+1'],
  ['Uruguay',                 'UY', '+598'],
  ['Uzbekistan',              'UZ', '+998'],
  ['Vietnam',                 'VN', '+84'],
  ['Yemen',                   'YE', '+967'],
]

export const ALL_COUNTRIES = [...PRIORITY_COUNTRIES, ...REST_OF_WORLD]

export function dialCodeFor(iso2) {
  const row = ALL_COUNTRIES.find((c) => c[1] === iso2)
  return row ? row[2] : ''
}

export function countryForDialCode(dialCode) {
  const code = String(dialCode || '').trim()
  if (!code) return ''
  const row = ALL_COUNTRIES.find((c) => c[2] === code)
  return row ? row[1] : ''
}

export function nameFor(iso2) {
  const row = ALL_COUNTRIES.find((c) => c[1] === iso2)
  return row ? row[0] : ''
}
